import { useState, useEffect } from 'react'

const useAuthImage = (url) => {
  const [src, setSrc] = useState(null)

  useEffect(() => {
    console.log('url:', url)
    if (!url) return

    let objectUrl = null

    const fetchImage = async () => {
        try {
            const token = localStorage.getItem('token')
            const res = await fetch(url, {
            headers: { Authorization: `Bearer ${token}` }
            })
            console.log('status', res.status)        // cek status responsenya
            console.log('ok', res.ok)                // harusnya true
            const blob = await res.blob()
            console.log('blob', blob)                // cek blob size, kalau 0 berarti kosong
            objectUrl = URL.createObjectURL(blob)
            console.log('objectUrl', objectUrl)      // cek url yang dihasilkan
            setSrc(objectUrl)
        } catch (err) {
            console.error('Failed to load image', err)
        }
    }

    fetchImage()

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [url])

  return src
}

export default useAuthImage